import * as types from './types';
export default {
  [types.SEND_ABTEST_TOGGLE](state, newState) {
    state.abtestToggleState = newState;
  },
  [types.SEND_ABTEST_TOOLTYPE_TOGGLE](state, newState) {
    state.abtestToggleTooltypeState = newState;
  }
};